import { render, staticRenderFns } from "./AdminStudyBaseRepeatable.vue?vue&type=template&id=4a3fd7a8&"
import script from "./AdminStudyBaseRepeatable.vue?vue&type=script&lang=js&"
export * from "./AdminStudyBaseRepeatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports